import { useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { FileCopy } from '@mui/icons-material';
import { useAtomValue } from 'jotai';
import * as state from '@/components/AssetLabelling/state';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';
import { updateCameraTargetUrlParameters } from '@/components/Analysis/deeplink';
import { textButtonStyle } from '@/theme';
import { OutlinedButton } from '@/modules/cuboids/components/CuboidToolbar/styles';

export const CopyViewButton = () => {
  const callbacks = useAtomValue(state.viewerCallbacks);
  const { showSnackBar } = useSnackBarMessage({ variant: 'filled' });

  const handleCopyView = useCallback(() => {
    const cameraTarget = callbacks?.getCameraPosition?.();
    if (cameraTarget) {
      updateCameraTargetUrlParameters(cameraTarget);
    }
    navigator.clipboard.writeText(window.location.href);
    showSnackBar('URL copied to clipboard', 'success');
  }, [callbacks, showSnackBar]);

  return (
    <Box sx={{ padding: '3px' }}>
      <OutlinedButton
        sx={textButtonStyle}
        variant="outlined"
        startIcon={<FileCopy style={{ color: '#fff' }} />}
        onClick={handleCopyView}
      >
        <Typography color={'#fff'}>Copy view</Typography>
      </OutlinedButton>
    </Box>
  );
};
